<template>
  <div id="postmanify">
    <index />
  </div>
</template>

<script>
import index from './pages/index'
import './assets/tailwind.css'

export default {
  name: 'App',
  components: {
    index,
  },
}
</script>
